import React from "react";
import Hero from "../components/Hero";
import { ProblemSection, PeaceOfMindSection, ComparisonSection } from "../components/Sections";
import { FeaturesSection, BenefitsSection } from "../components/Features";
import {
  BenefitsListSection, TestimonialsSection, PricingSection, FAQSection, TrustSection
} from "../components/MoreSections";

export default function Home() {
  return (
    <>
      <Hero />
      <ProblemSection />
      <PeaceOfMindSection />
      <ComparisonSection />
      <FeaturesSection />
      <BenefitsSection />
      <BenefitsListSection />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <TrustSection />
    </>
  );
}
